export class RBACService {
  private roleBasedAccessControl: string[] = [];

  constructor(rbac: String) {
    this.roleBasedAccessControl = rbac.split(";");
  }

  userHasAcessToResource(codeAccess: Number): Boolean {
    let hasAccess = false;
    for (let role of this.roleBasedAccessControl) {
      if (Number(role) === codeAccess) hasAccess = true;
    }

    return hasAccess;
  }
}
